import { useEffect,useState } from 'react';

import useUtilities from './useUtilities';
export const champRequisString = 'Champ requis';
export const isErrorObjectClean = (errorObject) => !Object.values(errorObject).some(value => value === champRequisString);
const useFormValidation = (requiredFields) => {
    const [isValid, setIsValid] = useState(false);
    const {setErrors, setShowErrors} =useUtilities(); //errors

    // * this logic of focusing on the field didn't work,, let do it later on
    // const [firstErrorInput, setFirstErrorInput] = useState(null);

    useEffect(() => {
        setShowErrors(false);
        setErrors({});

        let isFormValid = true;
        let newErrors = {};
        let firstError = null;
        console.log('requiredFields',requiredFields);
        requiredFields.forEach((field) => {
            if (Array.isArray(field.value)) {
                if (field.value.length === 0 ||
                    field.value.some((val) => val === '' || val == null)) {
                    isFormValid = false;
                    newErrors[field.name] = `${champRequisString} (minimum une valeur)`;
                } else {
                    newErrors[field.name] = '';
                }
            } else {
                if (field.value == '' || field.value == null) {
                    isFormValid = false;
                    newErrors[field.name] = champRequisString;
                    if (!firstError) {
                        console.log({field});
                        firstError = field?.ref;
                        // firstError = field;
                    }
                } else {
                    newErrors[field.name] = '';
                }
            }
        });

        setIsValid(isFormValid);
        setErrors(newErrors);
        // setFirstErrorInput(firstError); //I removed it since we don't need it, we focus more on the last one

        // const isFormValid = requiredFields.every((field) => field.value.trim() !== '');
        // setIsValid(isFormValid);
        // console.log('aaaa', requiredFields, isFormValid, newErrors);

        // let newErrors = {};
        // requiredFields.forEach((field) => {
        //     console.log('pppp',field);
        //     if (field.value.trim() === '') {
        //         newErrors[field.name] = 'champ requis'; //`${field.name} is required`
        //     } else {
        //         newErrors[field.name] = '';
        //     }
        // });
        // console.log('mmm',newErrors);
        // setErrors(newErrors);
        // // setErrors({});
        // console.log('bbb', firstErrorInput);
    }, [
        // otherwise if you pass only the requiredFields , it will cause an infinit loop
        requiredFields.map((field) => field.value).join(',')]);

    // useEffect(() => {
    //     if(requiredFields && errors)
    //         if(requiredFields[0]?.name !== errors[0]?.name)
    //             setErrors({});
    // }, []);
    // useEffect(() => {
    //     console.log('bbb', firstErrorInput, showErrors);
    //     if (firstErrorInput && showErrors) {
    //         firstErrorInput.focus();
    //     }
    // }, [firstErrorInput, showErrors]);

    return [isValid,
        // firstErrorInput,
        setIsValid];
};

export default useFormValidation;

// import { useEffect,useState } from 'react';

// import useUtilities from './useUtilities';

// const useFormValidation = (requiredFields) => {
//     const [isValid, setIsValid] = useState(false);
//     const { setInputErrors, setHelperText} =useUtilities();

//     useEffect(() => {
//         // const newErrors = { ...errors };
//         let newErrors = {};
//         // const newHelperText = { ...helperText };
//         const newHelperText = {  };

//         requiredFields.forEach((field) => {
//             if (field.value.trim() === '') {
//                 newErrors[field.name] = 'This field is required';
//                 newErrors[field.name] = true;
//                 newHelperText[field.name] = `${field.name} is required`;
//             } else {
//                 newErrors[field.name] = '';
//                 newErrors[field.name] = false;
//                 newHelperText[field.name] = '';
//             }
//         });
//         setInputErrors(newErrors);
//         setHelperText(newHelperText);
//         setIsValid(Object.values(newErrors).every((error) => !error));

//         const isFormValid = requiredFields.every((field) => field.value.trim() !== '');
//         setIsValid(isFormValid);
//     }, [requiredFields]);

//     return [isValid];
// };

// export default useFormValidation;
